import React, { useEffect, useState } from "react";
import DataTable from "../../../components/Website/DataTable";
import axios from "axios";
import { apiKey } from "../../../config/config";
import MessageCard from "../../../components/AdminCards/MessageCard";
import { RxCross1 } from "react-icons/rx";

function MyOrders({ logo }) {
  const customer = JSON.parse(localStorage.getItem("rms-customer"));
  const columns = [
    {
      header: "Order #",
      accessorKey: "sale_no",
    },
    {
      header: "Order Type",
      cell: (row) => row.row.original.order_type?.name,
    },
    {
      header: "Order Date",
      cell: (row) => getDateFromDatetime(row.row.original.sale_date),
    },
    {
      header: "Status",
      accessorKey: "order_status",
    },
    {
      header: "Actions",
      cell: (row) => (
        <button
          onClick={() => {
            setOpenInvoice(true);
            setInvoiceData(row.row.original);
          }}
          className="flex justify-center flex-col text-white rounded-lg px-2 py-1 border border-w-border bg-w-btn text-w-btn-text"
        >
          Invoice
        </button>
      ),
    },
  ];
  const [data, setData] = useState([]);
  const [openInvoice, setOpenInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [error, setError] = useState(null);

  function getDateFromDatetime(datetime) {
    const date = new Date(datetime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  useEffect(() => {
    axios
      .get(
        `${apiKey}/api/rms/customer/fetch_order_by_customer/${customer?.customer.id}`
      )
      .then((res) => {
        setData(res.data);
        setError(null);
      })
      .catch((err) => {
        setError(err.response.data.message || "Can't fetch orders.");
      });
  }, [customer?.customer.id]);
  return (
    <>
      <div className="w-full p-4">
        <h2 className="text-4xl font-semibold text-w-heading">All Orders</h2>
        {error && <MessageCard error={error} />}
        <DataTable columns={columns} data={data} footer={false} />
      </div>
      {openInvoice && (
        <div
          className="w-screen h-screen fixed top-0 left-0 bottom-0 overflow-y-auto backdrop-blur-xl bg-black bg-opacity-20 z-50 grid place-items-center py-4 fade-in"
          onClick={() => setOpenInvoice(false)}
        >
          <div
            className="max-w-3xl w-full rounded-lg shadow-lg bg-white relative fade-in-down"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setOpenInvoice(false)}
              className="absolute top-2 right-2"
            >
              <RxCross1 />
            </button>
            <div className="p-3 border-b">
              <img src={logo} className="w-36" alt="" />
            </div>
            <div className="p-3 space-y-4">
              <div className="max-w-[90%] text-center mx-auto w-full border border-black text-4xl">
                Invoice # {invoiceData?.sale_no}
              </div>
              <div className="grid grid-cols-2 gap-x-4 gap-y-1">
                <span>
                  <strong>Customer Name: </strong>
                  {invoiceData?.customer.name}
                </span>
                <span>
                  <strong>Payment Method: </strong>
                  {invoiceData?.payment.name}
                </span>
                <span>
                  <strong>Phone: </strong>
                  {invoiceData?.customer.phone}
                </span>
                <span>
                  <strong>Order Type: </strong>
                  {invoiceData?.order_type.name}
                </span>
                <span>
                  <strong>Address: </strong>
                  {invoiceData?.address}
                </span>
                <span>
                  <strong>Order Date: </strong>
                  {invoiceData?.date_time}
                </span>
              </div>
              <div>
                <h1 className="text-3xl font-bold">Order Summary</h1>
                <table className="w-full mt-4">
                  <thead>
                    <tr className="border-b border-black w-full">
                      <th className="text-start py-2">Item</th>
                      <th className="text-start py-2">Tax</th>
                      <th className="text-start py-2">Price</th>
                      <th className="text-start py-2">Qty</th>
                      <th className="text-start py-2">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceData?.order_details.map((item) => (
                      <tr className="border-b">
                        <td className="py-2">{item.name}</td>
                        <td className="py-2">
                          {item.menu_taxes.vat_percentage +
                            item.menu_taxes.additional_vat_percentage}
                          %
                        </td>
                        <td className="py-2">
                          {item.total_qty_discount && (
                            <span className="line-through">
                              {item.menu_taxes.total_price}
                            </span>
                          )}{" "}
                          <span>{item.menu_taxes.item_price.toFixed(2)}</span>
                        </td>
                        <td className="py-2">{item.qty}</td>
                        <td className="py-2">
                          {/* <span className="line-through">{item.menu_taxes.item_price.toFixed(2)}</span>{" "} */}
                          <span>
                            {item.menu_taxes.total_qty_items_price.toFixed(2)}
                          </span>
                        </td>
                      </tr>
                    ))}
                    <tr className="border-b">
                      <td className="py-2 font-bold" colSpan={4}>
                        Subtotal
                      </td>
                      <td className="py-2">{invoiceData?.sub_total}</td>
                    </tr>
                    <tr className="border-b">
                      <td className="py-2 font-bold" colSpan={4}>
                        Vat
                      </td>
                      <td className="py-2">{invoiceData?.vat_amount}</td>
                    </tr>
                    <tr className="border-b">
                      <td className="py-2 font-bold" colSpan={4}>
                        Discount
                      </td>
                      <td className="py-2">
                        {invoiceData?.total_discount_amount}
                      </td>
                    </tr>
                    <tr className="border-b">
                      <td className="py-2 font-bold" colSpan={4}>
                        Total
                      </td>
                      <td className="py-2">{invoiceData?.total_payable}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default MyOrders;
